import { Currency } from "lucide-react";

export const TransactionApiFactory = (requestId, apiData = {}) => {
    return {
        requestId: requestId || 0,
        transactionId: apiData.transactionId === "None" ? "" : apiData.transactionId || "",
        transactionType: apiData.transactionType || "",
        transactionReference: apiData.transactionReference || "",
        description: apiData.description || "",
        SaleType: apiData.saleType || "",
        salePrice: apiData.salePrice || "",
        purchasePrice: apiData.purchasePrice || "",
        headsOfTermDate: apiData.headsOfTermDate || "",
        anticipatedCompletionDate: apiData.anticipatedCompletionDate || "",
        ratePerAnnum: apiData.ratePerAnnum || "",
        term: apiData.term || "",
        price: apiData.purchasePrice || "",
        status: apiData.status || "Not Validated",
        currency: apiData.currency || "",
        duration: apiData.duration || "",
    };
};
